// extracted by mini-css-extract-plugin
module.exports = {"page":"styles-module--page--7Mvhk"};